import React, { useContext, useEffect, useState } from 'react'
import { Colorcontext } from '../../Component/Colorcontext/ColorContext';
import dashbordimg from "../../Images/dashbordimg.png";
import analyticsdashbordimage from "../../Images/analyticsdashbordimage.png";
import Rewards from "../../Images/Rewards.png";
import referernimg from "../../Images/referernimg.png"
const Membermasterdashbord = () => {
    const colordata = useContext(Colorcontext);
    useEffect(() => {

        colordata.setcolor(true);
        return () => {
            colordata.setcolor(false);
        };
    }, []);
    return (
        <section className='membermastersection'>
            <div className="cust_container">
                <div className='membermastersectionbg'>
                    <div className='membermastersectionbgtop'>
                        <div className='dashbordimgdtioodicflx'>
                            <div className='dashbordimgdivimg'>
                                <img src={dashbordimg} alt='...' />
                            </div>
                            <div className=''>
                                <p className='dahshnlisjhtxtpp'>Dashboard Links</p>
                            </div>
                        </div>
                    </div>
                    <div className='membermastersectionbgbottom'>
                        <div className='membermastersectionbgbottomdivflx'>
                            <div className='embermastersectionbgbobgmai'>
                                <div className='embermastersectionbgbobgmainnbg' style={{ backgroundColor: "#52DCFB" }}>
                                    <div className='analyticsshsimage'>
                                        <img src={analyticsdashbordimage} alt='...' />
                                    </div>
                                    <div className=''>
                                        <p className='alkantsrepposttxtpp'>Analytics <br/>
                                            Report</p>
                                    </div>
                                </div>
                            </div>
                            <div className='embermastersectionbgbobgmai'>
                                <div className='embermastersectionbgbobgmainnbg' style={{ backgroundColor: "#71D026" }}>
                                    <div className='analyticsshsimage'>
                                        <img src={Rewards} alt='...' />
                                    </div>
                                    <div className=''>
                                        <p className='alkantsrepposttxtpp'>Rewards <br/>
                                        Dashboard
                                            </p>
                                    </div>
                                </div>
                            </div>
                            <div className='embermastersectionbgbobgmai'>
                                <div className='embermastersectionbgbobgmainnbg' style={{ backgroundColor: "#D7A3FF" }}>
                                    <div className='analyticsshsimage'>
                                        <img src={referernimg} alt='...' />
                                    </div>
                                    <div className=''>
                                        <p className='alkantsrepposttxtpp'>Refer and earn <br/>
                                        Dashboard</p>
                                    </div>
                                </div>
                            </div>

                            <div className='embermastersectionbgbobgmai'>
                                <div className='embermastersectionbgbobgmainnbg' style={{ backgroundColor: "#D9D9D9" }}>
                                  
                                    <div className=''>
                                        <p className='alkantsrepposttxtppqueiytettcpp'>Quiz contest <br/>
                                        Dashboard</p>
                                    </div>
                                </div>
                            </div>
                            <div className='embermastersectionbgbobgmai'>
                                <div className='embermastersectionbgbobgmainnbg' style={{ backgroundColor: "#D9D9D9" }}>
                                  
                                    <div className=''>
                                        <p className='alkantsrepposttxtppqueiytettcpp'>Quiz contest <br/>
                                        Dashboard</p>
                                    </div>
                                </div>
                            </div>
                            <div className='embermastersectionbgbobgmai'>
                                <div className='embermastersectionbgbobgmainnbg' style={{ backgroundColor: "#D9D9D9" }}>
                                  
                                    <div className=''>
                                        <p className='alkantsrepposttxtppqueiytettcpp'>Quiz contest  <br/>
                                        Dashboard</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Membermasterdashbord
